import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MeetingsTable from './MeetingsTable';
import './CompletedMeetings.css';

function CompletedMeetings() {
  const navigate = useNavigate();

  return (
    <div className="completed-meetings-container">
      <div className="page-header">
        <button 
          className="back-button"
          onClick={() => navigate('/')}
        >
          ← Back to Home
        </button>
        <h1>Completed Meetings</h1>
      </div>
      
      <div className="meetings-section">
        <MeetingsTable 
          statusFilter="completed" 
          instanceTypeFilter={null}
          title=""
          showCreateButton={false}
        />
      </div>
    </div>
  );
}

export default CompletedMeetings;
